import { AutomationStatus } from '@repo/utils';

export enum AutomationListColumns {
  Name = 'name',
  Description = 'description',
  TriggerType = 'trigger_type',
  Status = 'status',
  ModifiedOn = 'updated_at',
  ModifiedBy = 'updated_by',
  CreatedOn = 'created_at',
}

export const AutomationListColumnsConfig: Record<AutomationListColumns, any> = {
  [AutomationListColumns.Name]: {
    dataIndex: 'name',
    sorter: true,
  },
  [AutomationListColumns.Description]: {
    dataIndex: 'description',
    sorter: false,
  },
  [AutomationListColumns.TriggerType]: {
    dataIndex: ['triggerNode', 'nodeSubType'],
    sorter: true,
  },
  [AutomationListColumns.Status]: {
    dataIndex: 'status',
    sorter: true,
  },
  [AutomationListColumns.ModifiedOn]: {
    dataIndex: 'updatedAt',
    sorter: true,
  },
  [AutomationListColumns.ModifiedBy]: {
    dataIndex: ['updatedBy', 'fullName'],
    sorter: false,
  },
  [AutomationListColumns.CreatedOn]: {
    dataIndex: 'createdAt',
    sorter: true,
  },
};

export enum AutomationListActions {
  Edit = 'edit',
  LiveEdit = 'liveEdit',
  Publish = 'publish',
  Unpublish = 'unpublish',
  Rename = 'rename',
  Clone = 'clone',
  Delete = 'delete',
  ViewReport = 'viewReport',
}

export const AutomationListActionsConfig: Record<AutomationListActions, any> = {
  [AutomationListActions.Edit]: {
    visibleForStatus: [AutomationStatus.draft, AutomationStatus.unpublished],
  },
  [AutomationListActions.LiveEdit]: {
    visibleForStatus: [AutomationStatus.published],
  },
  [AutomationListActions.Publish]: {
    visibleForStatus: [AutomationStatus.draft, AutomationStatus.unpublished],
  },
  [AutomationListActions.Unpublish]: {
    visibleForStatus: [AutomationStatus.published],
  },
  [AutomationListActions.Rename]: {
    visibleForStatus: Object.values(AutomationStatus),
  },
  [AutomationListActions.Clone]: {
    visibleForStatus: [AutomationStatus.draft, AutomationStatus.unpublished, AutomationStatus.published],
  },
  [AutomationListActions.Delete]: {
    visibleForStatus: [AutomationStatus.draft, AutomationStatus.unpublished],
  },
  [AutomationListActions.ViewReport]: {
    visibleForStatus: [AutomationStatus.unpublished, AutomationStatus.published],
  },
};
